var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-document-upload-form',{attrs:{"next-step-path":"SelfService-ReportDamage-Deadline","previous-step-path":"SelfService-ReportDamage-Facts"}})}
var staticRenderFns = []

export { render, staticRenderFns }